"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledText = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/styled-text"));

var _button = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/button"));

var _AlertCircleIcon = require("@zipwhip/zipkit/dist/icons/AlertCircleIcon");

var _constants = require("../../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Intro = function Intro(_ref) {
  var onStartRegistration = _ref.onStartRegistration,
      showReadOnlySummary = _ref.showReadOnlySummary;
  return (
    /*#__PURE__*/
    _react.default.createElement("div", {
      className: "".concat(_constants.STYLE_BASE, "_introBox")
    },
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20",
      type: "base"
    },
    /*#__PURE__*/
    _react.default.createElement("span", {
      className: "".concat(_constants.STYLE_BASE, "_introBoxIconRow")
    },
    /*#__PURE__*/
    _react.default.createElement(_AlertCircleIcon.AlertCircleIcon, {
      size: "24",
      color: "#FF8C50"
    }), ' ',
    /*#__PURE__*/
    _react.default.createElement("strong", null, "Your Action Required by March 1st, 2021"))),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      className: "mb-20",
      type: "base"
    }, "Complete the 10DLC registration process to ensure that your account is registered for business texting. We\u2019ll help you register using a few details about your business."),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      bold: true,
      className: "mb-20",
      type: "base"
    }, "Submit your business information before March 1 to avoid future service disruption and certain 10DLC\u202Ffees."), !showReadOnlySummary &&
    /*#__PURE__*/
    _react.default.createElement(_button.default, {
      className: "".concat(_constants.STYLE_BASE, "_startButton"),
      "data-testid": "10DLC_START_REGISTRATION_BUTTON",
      large: true,
      onClick: onStartRegistration
    }, "Register Now"))
  );
};

var _default = Intro;
exports.default = _default;